var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"attributes",rawName:"v-attributes",value:(_vm.schema.attributes),expression:"schema.attributes"}]},[_c('img',{ref:"image"})])}
var staticRenderFns = []

export { render, staticRenderFns }